
import React from 'react';
import { useCheckoutStore } from '@/stores/checkoutStore';
import CheckoutSummary from './CheckoutSummary';

interface CheckoutLayoutProps {
  children: React.ReactNode;
  course: any;
}

const CheckoutLayout = ({ children, course }: CheckoutLayoutProps) => {
  const { finalAmount } = useCheckoutStore();
  
  return (
    <div className="container max-w-7xl mx-auto py-8 px-4 md:py-12">
      <h1 className="text-2xl font-bold mb-8 text-center md:text-left">Kassa</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
        {/* Main checkout form */}
        <div className="md:col-span-8 space-y-6">
          {children}
        </div>
        
        {/* Order summary */}
        <div className="md:col-span-4">
          <div className="sticky top-24">
            <CheckoutSummary course={course} amount={finalAmount} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutLayout;
